import { IAppConstants, restServer } from '../app.constants';
import { IPromise, IHttpResponse } from 'angular';
import { REST_SERVER_URL } from '../config';

declare var $http: any;

export const RegisterUserService: Function = (user: any, successCallback: any, errorCallback: any) => {
    // make activation code field empty
    let req = {
        method: 'POST',
        url: REST_SERVER_URL + '/register/user',
        headers: {
            'Content-Type': 'application/json'
        },
        data: this.user
    };
    $http(req).then(successCallback, errorCallback);
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/register-user.service.ts